import { SelectionFieldHandler } from './field-handlers/selection-handler';
import { BaseHandler } from './field-handlers/base-handler.js';

export function getFieldHandler(el: HTMLElement): BaseHandler {
  const type = (el as HTMLInputElement).type;
  const nodeName = el.nodeName.toUpperCase();

  if (type === 'checkbox' || type === 'radio' || nodeName === 'SELECT') {
    return new SelectionFieldHandler(el);
  }

  return new BaseHandler(el);
}
